import { api } from "./http-client";
import { User } from "../interfaces/user.interface";
import { CreateAdminDto, UpdateAdminDto, AdminPageOptionsDto } from "../dtos/admin.dto";

export const adminsService = {
  list: async (params?: AdminPageOptionsDto): Promise<User[]> => {
    const response = await api.request<User[]>({
      url: "/admins",
      method: "GET",
      params,
    });
    return response.data;
  },
  create: async (data: CreateAdminDto): Promise<User> => {
    const response = await api.request<User>({
      url: "/admins",
      method: "POST",
      data,
    });
    return response.data;
  },
  update: async (id: string, data: UpdateAdminDto): Promise<User> => {
    const response = await api.request<User>({
      url: `/admins/${id}`,
      method: "PATCH",
      data,
    });
    return response.data;
  },
  remove: async (id: string): Promise<void> => {
    await api.request({
      url: `/admins/${id}`,
      method: "DELETE",
    });
  },
};
